<template>
  <section>
    <div class="ml-3" v-for="item in items" :key="item.tableauMenuFolderId">
      <single-node :item="item" />
    </div>

    <div class="ml-3">
      <div v-for="report in reports" :key="report.tableauMenuConfigId">
        <report-node :report="report" />
      </div>
    </div>
  </section>
</template>

<script>
import singleNode from './SingleNode.vue';
import reportNode from './ReportNode.vue';

export default {
  name: 'TreeNode',
  components: { singleNode, reportNode },
  props: { items: Array, reports: Array },
  data() {
    return {
      showChildren: false,
    };
  },
  methods: {
    // selectedReport(id) {
    //   // this.$emit('selectedReport', id);
    // }
  },
};
</script>

<style scoped>
.icon-button {
  visibility: hidden;
  display: inline-block;
  cursor: pointer;
  float: right;
  vertical-align: bottom;
  z-index: 10;
}

.title-box {
  display: inline-block;
  width: calc(100% - 30px);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.title-box:visited {
  color: inherit !important;
}

.title-box:focus {
  color: inherit !important;
}

.title-box:hover {
  color: inherit !important;
  text-decoration: none !important;
}
</style>
